var map = {
	"./albanian.jpg": 971,
	"./amharic.jpg": 972,
	"./arabic.jpg": 973,
	"./argentina.jpg": 974,
	"./armenian.jpg": 975,
	"./austria.jpg": 976,
	"./azerbaijani.jpg": 977,
	"./basque.jpg": 978,
	"./belarusian.jpg": 979,
	"./bengali.jpg": 980,
	"./bosnian.jpg": 981,
	"./brazilian portugese.jpg": 982,
	"./bulgarian.jpg": 983,
	"./canadian french.jpg": 984,
	"./catalan.jpg": 985,
	"./chinese simplified.jpg": 986,
	"./chinese traditional.jpg": 987,
	"./chinese.jpg": 988,
	"./croatian.jpg": 989,
	"./czech.jpg": 990,
	"./danish.jpg": 991,
	"./dari.jpg": 992,
	"./dutch.jpg": 993,
	"./egypt.jpg": 994,
	"./english.jpg": 995,
	"./estonian.jpg": 996,
	"./ethiopia.jpg": 997,
	"./finnish.jpg": 998,
	"./flemish.jpg": 999,
	"./french.jpg": 1000,
	"./galician.jpg": 1001,
	"./georgian.jpg": 1002,
	"./german.jpg": 1003,
	"./greek.jpg": 1004,
	"./greenlandic.jpg": 1005,
	"./hebrew.jpg": 1006,
	"./hindi.jpg": 1007,
	"./hungarian.jpg": 1008,
	"./icelandic.jpg": 1009,
	"./indian.jpg": 1010,
	"./indonesian.jpg": 1011,
	"./irish.jpg": 1012,
	"./italian.jpg": 1013,
	"./japanese.jpg": 1014,
	"./kazakh.jpg": 1015,
	"./khmer.jpg": 1016,
	"./korean.jpg": 1017,
	"./latin.jpg": 1018,
	"./latvian.jpg": 1019,
	"./lithuanian.jpg": 1020,
	"./luxembourgian.jpg": 1021,
	"./macedonian.jpg": 1022,
	"./malay.jpg": 1023,
	"./maltese.jpg": 1024,
	"./mexican spanish.jpg": 1025,
	"./mexican.jpg": 1026,
	"./moldavian.jpg": 1027,
	"./montenegrin.jpg": 1028,
	"./nepali.jpg": 1029,
	"./norwegian.jpg": 1030,
	"./persian.jpg": 1031,
	"./persian_old.jpg": 1032,
	"./polish.jpg": 1033,
	"./portugese.jpg": 1034,
	"./romanian.jpg": 1035,
	"./russian.jpg": 1036,
	"./serbian.jpg": 1037,
	"./slovak.jpg": 1038,
	"./slovenian.jpg": 1039,
	"./south-america spanish.jpg": 1040,
	"./spanish.jpg": 1041,
	"./srilanka.jpg": 1042,
	"./swahili.jpg": 1043,
	"./swedish.jpg": 1044,
	"./tagalog.jpg": 1045,
	"./taiwan.jpg": 1046,
	"./tamil.jpg": 1047,
	"./thai.jpg": 1048,
	"./turkish.jpg": 1049,
	"./turkmen.jpg": 1050,
	"./ukrainian.jpg": 1051,
	"./urdu.jpg": 1052,
	"./usa.jpg": 1053,
	"./uyghur.jpg": 1054,
	"./uzbek.jpg": 1055,
	"./vietnamese.jpg": 1056
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 970;